import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { chiedereConsenso, DOMANDA_CONSENSO } from "@/lib/consensoMarketing";

/**
 * La domanda del consenso alle offerte, una volta sola (02/11/2026): una
 * striscia sotto la testata, come il BannerProva, che non blocca la chat.
 * Sparisce alla risposta; si cambia idea dalle impostazioni.
 */
export function DomandaConsenso() {
  const { user, profile, refreshProfile } = useAuth();
  const [risposta, setRisposta] = useState<boolean | null>(null);
  const [inCorso, setInCorso] = useState(false);

  if (risposta !== null || !chiedereConsenso(profile, user?.email)) return null;

  const rispondi = async (si: boolean) => {
    if (!user?.id || inCorso) return;
    setInCorso(true);
    const { error } = await supabase.from("profiles").update({ consenso_marketing: si }).eq("id", user.id);
    setInCorso(false);
    if (error) {
      toast.error("Non sono riuscito a salvare la risposta, riprova.");
      return;
    }
    setRisposta(si);
    toast.success(si ? "Ti scriveremo quando c'è qualcosa di utile." : "Va bene: niente offerte via email.", {
      description: "Puoi cambiare idea nelle impostazioni.",
    });
    void refreshProfile();
  };

  return (
    <div className="border-b border-border/60 bg-card px-3 py-2.5 text-[13px]">
      <div className="mx-auto flex max-w-3xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <p className="flex items-start gap-2">
          <Mail className="mt-0.5 h-3.5 w-3.5 shrink-0 text-primary" aria-hidden="true" />
          <span>{DOMANDA_CONSENSO}</span>
        </p>
        <div className="flex shrink-0 gap-2 pl-5 sm:pl-0">
          <Button size="sm" className="min-h-9" disabled={inCorso} onClick={() => void rispondi(true)}>
            Sì, mandamele
          </Button>
          <Button size="sm" variant="outline" className="min-h-9" disabled={inCorso} onClick={() => void rispondi(false)}>
            No, grazie
          </Button>
        </div>
      </div>
    </div>
  );
}
